<div class="content-wrapper" style="margin-bottom: 100px">
  <div class="col-md-12 layout-spacing" style="margin-top: 30px">
    <div class="row" style="height: 60vh;">
      
      <div class="col-md-6">
        <div class="card" style="height: 100%;">
          <div class="no-gutters row" style="height: 100%;">
            <div class="row" style="height: 100%;">
              <div class="col-md-5 custom-manual">
                <div class="new-arrival-product">
                  <div class="new-arrivals-img-contnent">
                    <img [src]="currentLang == 'es' ? 'assets/img/manuals/User-Manual.png' : 'assets/img/manuals/User-Manual.png'" alt="Skote" class="img-fluid card-img">
                  </div>
                </div>
                <a [href]="currentLang == 'es' ? '/assets/manuals/SafeCloud-Manual-usuario.pdf' : '/assets/manuals/SafeCloud-User-Manual.pdf'" target="_blank" class="btn btn-primary btn-rounded mt-4">{{ 'record.download.download' | translate }}</a>
              </div>
            <div class="col-md-7">
                <div class="card-body">
                    <div class="card-title text-bold">
                      <a [href]="currentLang == 'es' ? '/assets/manuals/SafeCloud-Manual-usuario.pdf' : '/assets/manuals/SafeCloud-User-Manual.pdf'" target="_blank">
                        <h5>{{ 'manual.user.title' | translate }}</h5>
                      </a>
                    </div>
                    <p class="card-text">
                      <small class="text-muted">{{ 'manual.user.author' | translate }}</small>
                    </p>
                    <p class="card-text">{{ 'manual.user.description' | translate }}</p>
                  </div>
            </div>
            </div>
        </div>
        </div>
      </div>
     
    </div>
  </div>
</div>
